import axios from 'axios';
import { properties } from '../properties';

const API_BASE_URL = properties.backendApi;

const codeExecutionService = {
  executeCode: async (sourceCode, languageId = '62', stdin = '') => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${API_BASE_URL}/code/execute`,
        {
          sourceCode,
          languageId,
          stdin
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default codeExecutionService; 